import React, { memo, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { clearUsedGoodsDetail, getUsedGoodsDetail } from "../../../../../store/actions/usedGoods";
import VaporDrawer from "../../../../general/vapor/drawer";
import FormBuy from "./formBuy";
import UsedGoodsSearch from "./search";

const UsedGoodsDrawer = ({currency, draftId, goodsId, onClose, visible}) => {
  
  const dispatch = useDispatch();
  const isSellingInvoice = useSelector(state => state.precog?.invoiceDetail?.data?.doc?.active);
  // quando si clicca su toggle spesa accessoria da 
  const [accessoryExpense, setAccessoryExpense] = useState(false);
  const [goodsSearched, setGoodsSearched] = useState(null);

  useEffect(() => {      
    if (!visible) return undefined;
    dispatch(getUsedGoodsDetail(draftId, goodsId)).then((res) => {      
      setAccessoryExpense(res.increaseExistingGood);
    }).catch(e => {});
    return () => {
      dispatch(clearUsedGoodsDetail());
    };
  }, [goodsId, visible]);
  
  return (
    <VaporDrawer
      onClose={() => {
        onClose();
        setAccessoryExpense(false);
      }}
      visible={visible}
      title={
        <>
          {
            (isSellingInvoice || !goodsSearched) &&
            <><FormattedMessage id="preCog.usedGoods.title" /> / &nbsp;</>
          }          
          {
            !isSellingInvoice && accessoryExpense &&
            <FormattedMessage id="preCog.usedGoods.selectUsedGoods" /> 
          }
          {
            isSellingInvoice &&
            <FormattedMessage id="preCog.usedGoods.sell" />
          }
          {
            !isSellingInvoice && !accessoryExpense &&
            <FormattedMessage id="preCog.usedGoods.buy" /> 
          }
          
        </>
      }
      width={720}
      maskClosable={false}
      buttons={null}
      hideFooter={true}
    >
      { /**  */
        !isSellingInvoice && !accessoryExpense &&
          <FormBuy onCloseDrawer={()=>onClose()} accessoryExpense={accessoryExpense} 
            currency={currency}
            draftId={draftId} goodsId={goodsId}
            setAccessoryExpense={setAccessoryExpense} />
      }
      {
        (isSellingInvoice || (!isSellingInvoice && accessoryExpense && !goodsSearched)) &&
          <UsedGoodsSearch setGoodsSearched={setGoodsSearched} />        
      }
    </VaporDrawer>
  );
};

export default memo(UsedGoodsDrawer);